/** User-facing identity, deliberately separate from package and infrastructure names. */
export const productIdentity = {
  displayName: "PapersFlow",
  slug: "papersflow",
  isWorkingTitle: false,
} as const;
